<template>
<div>
  <keep-alive>
    <router-view></router-view>
  </keep-alive>
</div>
</template>
<script>

export default {
  name: 'FormWrap',
  data() {
    return {
      
    };
  },
  mounted() {
    // console.log('-----------------------------------------');
  },
  methods: {

  },
  watch: {

  },
};
</script>
<style lang="scss" scoped="" type="text/css">

</style>
